import { render, staticRenderFns } from "./RecentTransaction.vue?vue&type=template&id=63455300&"
import script from "./RecentTransaction.vue?vue&type=script&lang=js&"
export * from "./RecentTransaction.vue?vue&type=script&lang=js&"
import style0 from "./RecentTransaction.vue?vue&type=style&index=0&id=63455300&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports